import type { FileStat, FileSystem } from "@ex0/kernel";
import * as BrowserFS from "browserfs";
import promisify from "util.promisify";

export async function createBrowserFileSystem(): Promise<FileSystem> {
  BrowserFS.install(window);
  (window as unknown as Record<string, unknown>).BrowserFS = BrowserFS;

  await new Promise<void>((resolve, reject) => {
    BrowserFS.configure(
      {
        fs: "MountableFileSystem",
        options: {
          "/tmp": { fs: "InMemory" },
          "/home": { fs: "LocalStorage" },
        },
      },
      (e) => {
        if (e) {
          reject(e);
        } else {
          resolve();
        }
      },
    );
  });

  const fs = BrowserFS.BFSRequire("fs");
  const readFile = promisify(fs.readFile) as (path: string) => Promise<Buffer>;
  const readdir = promisify(fs.readdir) as (path: string) => Promise<string[]>;
  const writeFile = promisify(fs.writeFile) as (
    path: string,
    data: string | Uint8Array,
  ) => Promise<void>;
  const mkdir = promisify(fs.mkdir) as (path: string) => Promise<void>;
  const statFn = promisify(fs.stat) as (
    path: string,
  ) => Promise<{ isFile(): boolean; isDirectory(): boolean; size: number }>;

  return {
    async readFile(path: string): Promise<Uint8Array> {
      const buf = await readFile(path);
      return new Uint8Array(buf);
    },
    readdir,
    writeFile,
    mkdir,
    async stat(path: string): Promise<FileStat> {
      const s = await statFn(path);
      return {
        isFile: () => s.isFile(),
        isDirectory: () => s.isDirectory(),
        size: s.size,
      };
    },
  };
}
